/**
 * We take the approach of organizing each “cast member” in a scene within its own file.
 * This is a choice and isn’t required, but it does isolate internal changes/enhancements
 * to these specific “characters.”
 */

import { CylinderGeometry, MeshToonMaterial, Mesh, Group, Box3 } from 'three'

 class Coraltrunk {
   constructor(color, x, y, z) {
     this.geometry = new CylinderGeometry(.1, .3, 3, 3)
     this.material = new MeshToonMaterial({ color })
     this.mesh = new Mesh(this.geometry, this.material)
     this.mesh.position.set(x, y, z)
   }
 }

 class Coralbranch {
   constructor(color, x, y, z) {
     this.geometry = new CylinderGeometry(.2, .3, 3, 3)
     this.material = new MeshToonMaterial({ color})
     this.material.transparency = true
     //this.material.alphaMap = 'black'
     this.mesh = new Mesh(this.geometry, this.material)
     this.mesh.position.set(x-1, y, z)
     this.mesh.rotation.z = Math.PI / 4

     this.geometryright = new CylinderGeometry(.2, .3, 3, 3)
     this.materialright = new MeshToonMaterial({ color})
     this.meshright = new Mesh(this.geometryright, this.materialright)
     this.meshright.position.set(x+1, y, z)
     this.meshright.rotation.z = Math.PI / -4

     this.group = new Group()
     this.group.add(this.mesh, this.meshright)
     this.group.position.set(x, y, z)

   }
 }

 class FlatCoral {
   constructor(color, x,y,z, thickness) {
     var scale = 1
     const coraltrunk = new Coraltrunk( color, x,y,z)
     const branchgroup = new Group()
     //const bindgroup = new Group()
     //this.vector = new Vector3(x,y,z)
     branchgroup.position.set(x, y-1, z)
     branchgroup.scale.set(1,1, thickness)
     this.group = new Group()
     this.group.position.set(x,y,z)
     this.materials = [coraltrunk.material]

     var box = new Box3().setFromObject( this.group );
     box.getCenter( branchgroup.position ); // this re-sets the mesh position
     box.getCenter( coraltrunk.mesh.position)
     coraltrunk.mesh.position.y += 1

     this.group.add(coraltrunk.mesh, branchgroup)

     this.materials = branchmaker(-1.4,1,z, 1, this.materials)
     scale *= .9
     this.materials = branchmaker(-3.6,2.6,z, 1.7, this.materials)
     this.materials = branchmaker(-1.3,1.8,z, .2, this.materials)
     this.materials = branchmaker(-1.3,.4,z, .1, this.materials)
     scale *= .9
     this.materials = branchmaker(-2.1,3.8,z, .95, this.materials)
     this.materials = branchmaker(-.8,2.7,z, -.1, this.materials)
     this.materials = branchmaker(-4,3.4,z, 1.3, this.materials)
     this.materials = branchmaker(-.9,4,z, 0.5, this.materials)
     scale *= .7
     this.materials = branchmaker(-8.9,5.2,z, 2, this.materials)
     this.materials = branchmaker(-4.9,4.2,z, 1, this.materials)
     this.materials = branchmaker(-5.2,1.5,z, -.7, this.materials)
     this.materials = branchmaker(-4.5,3.8,z, 0.1, this.materials)
     scale*=.7
     this.materials = branchmaker(-3.1,1.8,z, .65, this.materials)
     this.materials = branchmaker(-2.9,5.3,z, .5, this.materials)
     this.materials = branchmaker(-1.35,5.8,z, 0.1, this.materials)
     this.materials = branchmaker(.25,4.4,z, .7, this.materials)
     this.materials = branchmaker(-0.7,1.4,z, -0.5, this.materials)
     this.materials = branchmaker(0,6,z, 0, this.materials)

     function branchmaker(x,y,z, rotation, materials) {
         const leftBranch = new Coralbranch(color, x, y, z )
         leftBranch.group.scale.set(scale,scale,scale)
         leftBranch.group.rotation.z = rotation;
         branchgroup.add(leftBranch.group)
         materials.push(leftBranch.material)
         materials.push(leftBranch.materialright)

         const rightBranch = new Coralbranch(color, - x, y, z )
         rightBranch.group.scale.set(scale,scale,scale)
         rightBranch.group.rotation.z = rotation - (rotation * 2) ;
         branchgroup.add(rightBranch.group)
         materials.push(rightBranch.material)
         materials.push(rightBranch.materialright)

         return materials
     }
   }
 }

export default FlatCoral
